import { getUserId } from './userIdentity';

/**
 * İskeletle gelen yer tutucu; gerçek adres girilene kadar backend yok.
 *
 * `: string` açıklaması BİLİNÇLİ. Olmadan TypeScript bu sabiti "tam
 * olarak şu metin" tipine daraltıyor, aşağıdaki karşılaştırmanın
 * sonucunu derleme anında hesaplıyor ve sonucu belli bir
 * karşılaştırmayı hata sayıyor (TS2367). `string` demek, kontrolü
 * çalışma anına bırakır.
 */
const API_URL_PLACEHOLDER: string = 'https://discipline-api.YOUR-SUBDOMAIN.workers.dev';
/** Yayınlanmış Worker adresi. */
export const API_BASE_URL = 'https://discipline-api.discipline-backend.workers.dev';

/**
 * Backend adresi girilmiş mi?
 *
 * Yer tutucu adrese istek atmak, var olmayan bir sunucuya bağlanmaya
 * çalışmak demektir: her çağrı ağ hatasıyla biter ve konsolu gereksiz
 * hatalarla doldurur. Çağıranlar önce bunu sorup sessizce vazgeçebilir.
 */
export function isApiConfigured(): boolean {
  return API_BASE_URL !== API_URL_PLACEHOLDER;
}

interface RequestOptions {
  method?: 'GET' | 'POST' | 'DELETE';
  body?: unknown;
}

/**
 * Calls the backend, automatically attaching the device's userId so
 * records stay separated per person.
 */
export async function apiRequest<TResponse>(
  path: string,
  options: RequestOptions = {},
): Promise<TResponse> {
  const init: RequestInit = {
    method: options.method ?? 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  if (options.body) {
    init.body = JSON.stringify({ ...options.body, userId: getUserId() });
  }

  const response = await fetch(`${API_BASE_URL}${path}`, init);

  if (!response.ok) {
    throw new Error(`API request failed: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<TResponse>;
}
